import { MessageFormat } from '@paypalcorp/worldready'
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'
import {
  Button,
  HeadingText,
  Checkbox,
  CheckboxGroup,
  Alert,
  Sheet,
} from '@paypalcorp/pp-react'
import React, { useContext, useState } from 'react'
import apiClient from '../../api'
import PropTypes from 'prop-types'

const EditPerm = (props) => {
  const worldReady = useContext(WorldReadyContext)
  const { party, permissions } = props
  const [grantedPermissions, setGrantedPermissions] = useState(
    party.grantedPermissions,
  )
  const [btnState, setBtnState] = useState('initial')
  const [error, setError] = useState(null)
  const baseClass =
    props.windowWidth <= props.mobileScreenSize
      ? 'tpp_dialogMobile'
      : 'tpp_dialog'

  const successMsg = new MessageFormat(worldReady, {
    id: `thirdPartyPerm.editSuccess`,
  }).format({ api_username: props.party.apiUsername })

  const onSubmit = () => {
    if (grantedPermissions.length === 0) {
      setError(
        new MessageFormat(worldReady, {
          id: `thirdPartyPerm.noPermissionSelectedError`,
        }).format(),
      )
      return
    }
    const entry = {
      apiUsername: party.apiUsername,
      Organization: party.Organization,
      grantedPermissions,
      accountNumber: party.accountNumber,
    }

    setBtnState('processing')
    apiClient
      .post(`/editEntry`, { entry })
      .then((response) => {
        setBtnState('success')
        setError(null)
        props.closeSuccessSheet(successMsg, 'edit', response.data)
        return null
      })
      .catch((e) => {
        props.errorHandler(e, setError, worldReady, setBtnState)
      })
  }

  const renderFooter = () => {
    return (
      <div className="tppEdit_Footers">
        <Button
          className="tpp_btn"
          id="editPermsBtn"
          data-pa-click="editPermsBtn"
          onClick={onSubmit}
          btnState={btnState}
        >
          <Message id="thirdPartyPerm.saveButton" />
        </Button>
      </div>
    )
  }

  const handleChange = (name, checked) => {
    if (checked) {
      setGrantedPermissions([...grantedPermissions, name])
    } else {
      setGrantedPermissions(grantedPermissions.filter((e) => e !== name))
    }
  }

  const renderOtherPerms = () => {
    return permissions.map((p, index) => {
      return (
        <div className="perm_div" key={index}>
          <Checkbox
            className="tpp_checkbox"
            id={`perm_${p.name}`}
            checked={grantedPermissions.includes(p.name)}
            label={<Message id={`thirdPartyPerm.${p.text_ref}`} />}
            onChange={(e) => handleChange(p.name, e.target.checked)}
          />
        </div>
      )
    })
  }

  return (
    <Sheet
      noPadding
      className={baseClass}
      isOpen={props.isEditOpen}
      containerClassName="tpp_sheetContainer"
      wrapperClassName="tpp_sheetWrapper"
      onCloseComplete={() => {
        props.setEditOpen({ type: 'edit', value: false })
        props.setToChange({})
      }}
      footerContents={renderFooter()}
      footerAlign="center"
      showLogo={true}
      skipFormFocus={true}
    >
      {error && (
        <div className="tppError_div">
          <Alert type="error" className="tppError_alert" id="editErrorAlert">
            {error}
          </Alert>
        </div>
      )}
      <div>
        <HeadingText level={2} className="tppView_Heading view_heading">
          <Message id="thirdPartyPerm.editHeading" />
        </HeadingText>
      </div>
      <div className="view_subHeadingUpper">
        <div className="view_subHeading">
          <p>
            <Message id="thirdPartyPerm.thirdPartyUsername" />:{' '}
            <strong id="editApiUsername">{props.party.apiUsername}</strong>
          </p>
        </div>
        <div className="view_subHeading">
          <p>
            <Message id="thirdPartyPerm.organization" />:{' '}
            <strong id="editOrganization">{props.party.Organization}</strong>
          </p>
        </div>
      </div>
      <div className="checkBoxGroup">
        <div>
          <Message id="thirdPartyPerm.availablePermissions" />
        </div>
        <CheckboxGroup>{renderOtherPerms()}</CheckboxGroup>
      </div>
    </Sheet>
  )
}

EditPerm.propTypes = {
  party: PropTypes.object,
  permissions: PropTypes.array,
  setEditOpen: PropTypes.func,
  setToChange: PropTypes.func,
  isEditOpen: PropTypes.any,
  errorHandler: PropTypes.func,
  closeSuccessSheet: PropTypes.func,
  windowWidth: PropTypes.any,
  mobileScreenSize: PropTypes.any,
}

export default EditPerm
